module.exports = __webpack_public_path__ + "static/img/title_bg_2.939386d2.jpg";